<div class="agpr-textDisplay">
    <div
        [ngStyle]="{
            'text-align': data.styles.alignment,
            'background-color': data.styles.backgroundColor,
            'font-weight': data.styles.bold ? 'bold' : 'normal',
            'color': data.styles.color,
            'font-family': data.styles.fontFamily,
            'font-size': data.styles.fontSize,
            'font-style': data.styles.italics ? 'italic' : 'normal',
            'text-decoration': data.styles.underlined ? 'underline' : 'none',
            'display': 'block',
            'padding-top': data.styles.padding.paddingOption
                ? (data.styles.padding.topPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-right': data.styles.padding.paddingOption
                ? (data.styles.padding.rightPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-bottom': data.styles.padding.paddingOption
                ? (data.styles.padding.bottomPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-left': data.styles.padding.paddingOption
                ? (data.styles.padding.leftPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px'
        }"
        [innerHTML]="safeText"
    >
    </div>
</div>